module.exports = __webpack_public_path__ + "img/coins.ec7f8d69.png";